import { render, staticRenderFns } from "./ui-select.vue?vue&type=template&id=0169a0f4&scoped=true&"
import script from "./ui-select.vue?vue&type=script&lang=js&"
export * from "./ui-select.vue?vue&type=script&lang=js&"
import style0 from "./ui-select.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ui-select.vue?vue&type=style&index=1&id=0169a0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0169a0f4",
  null
  
)

export default component.exports